import React, { useEffect, useState } from 'react';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../../../server/firebase';
import './miperfil.css';

function MiPerfil({ userEmail, onLogout }) {
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserName = async () => {
      if (!userEmail) {
        setLoading(false);
        return;
      }

      try {
        const docRef = doc(db, 'ADMINISTRADORES', 'DOCENTES');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const emailKey = userEmail.toLowerCase();

          if (data[emailKey]) {
            setUserName(data[emailKey].name);
          } else {
            setUserName('Usuario');
          }
        } else {
          setUserName('Usuario');
        }
      } catch (error) {
        console.error('Error obteniendo nombre:', error);
        setUserName('Usuario');
      } finally {
        setLoading(false);
      }
    };

    fetchUserName();
  }, [userEmail]);

  return (
    <div className="miperfil-content-section">
      <h1>👤 Mi Perfil</h1>

      {loading ? (
        <p className="miperfil-loading">Cargando información...</p>
      ) : (
        <div className="miperfil-container">

          {/* CARD PRINCIPAL */}
          <div className="miperfil-card">
            <div className="miperfil-avatar">
              <div className="miperfil-avatar-placeholder">
                {userName
                  ? userName.charAt(0).toUpperCase()
                  : userEmail
                    ? userEmail.charAt(0).toUpperCase()
                    : 'U'}
              </div>
            </div>

            <div className="miperfil-info">
              <h2>{userName || userEmail || 'Usuario'}</h2>
              <p className="miperfil-role">Docente</p>
            </div>
          </div>

          {/* DETALLES */}
          <div className="miperfil-details">
            <div className="miperfil-detail-item">
              <label>Email:</label>
              <p>{userEmail}</p>
            </div>

            <div className="miperfil-detail-item">
              <label>Estado:</label>
              <p>Activo</p>
            </div>

            <div className="miperfil-detail-item">
              <label>Cursos Inscritos:</label>
              <p>3 cursos</p>
            </div>
          </div>

          {/* BOTÓN */}
          <button className="miperfil-btn-logout" onClick={onLogout}>
            Cerrar Sesión
          </button>

        </div>
      )}
    </div>
  );
}

export default MiPerfil;